
import { getElements, getClasses } from './components.site-navigation';

var initialised = false,
	elements,
	classes;

export function navIsInitialised() {
	return initialised;
}

function removeAllActiveClasses() {
	elements.siteNavItemWithChildren.forEach( item => {
		item.classList.remove('is-active');
	});

	elements.siteNavSubItemWithChildren.forEach( item => {
		item.classList.remove('is-active');
	});
}

export function reset() {

	if ( navIsInitialised() ) {

		initialised = false;

		// close all sub navs
		removeAllActiveClasses();

		elements.subNav.forEach( item => {
			item.setAttribute('style', '');
		});

		elements.subSubNav.forEach( item => {
			item.setAttribute('style', '');
		});

		removeEventListeners();
	}
}

function handleSiteNavItemWithChildrenClick(e) {
	e.preventDefault();
			
	let clickedElem = e.currentTarget;
	let subNav = clickedElem.nextElementSibling;

	if ( clickedElem.classList.contains('is-active') ) {
		// if item collapsed and text of link clicked, then go to the page
		if ( e.target.classList.contains('js-link-text-wrap') ) {
			window.location = clickedElem.getAttribute('href');
		}
		else {
			subNav.style.display = 'none';
			clickedElem.classList.remove('is-active');
		}
	} else {
		subNav.style.display = 'block';
		clickedElem.classList.add('is-active');
	}
}

function addEventListeners() {
	elements.siteNavItemWithChildren.forEach( item => {
		item.addEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	elements.siteNavSubItemWithChildren.forEach( item => {
		item.addEventListener('click', handleSiteNavItemWithChildrenClick);
	});
}

function removeEventListeners() {
	elements.siteNavItemWithChildren.forEach( item => {
		item.removeEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	elements.siteNavSubItemWithChildren.forEach( item => {
		item.removeEventListener('click', handleSiteNavItemWithChildrenClick);
	});
}

export function init() {

	elements = getElements();
	classes = getClasses();

	if ( ! navIsInitialised() ) {

		elements.subNav.forEach( item => {
			item.style.opacity = 1;
			item.style.display = 'none';
		});

		elements.subSubNav.forEach( item => {
			item.style.opacity = 1;
			item.style.display = 'none';
		});

		initialised = true;

		addEventListeners();
	}
}